import { Injectable } from '@angular/core';
import {environment} from "../../../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {ApplicantBasicInfoResponse} from "../../../Shared/models/ApplicationtPersonalDetailsModels";
import {
  AppealApplicantDetailsResponse
} from "../../../../beneficiary/Modules/appeal/Models/Responses/AppealApplicantDetailsResponse";
import {ApplicantAppealModel} from "../../../../beneficiary/Modules/appeal/Models/ApplicantAppealModel";
import {AppealRitaDetails, TasafAppealResponse} from "../../../../beneficiary/Modules/appeal/Models/AppealRitaDetails";

@Injectable({
  providedIn: 'root'
})
export class AppealV2Service {
  appeal_info_url = environment.appeal_base_url;

  constructor(
    private http: HttpClient,
  ) {
  }


  getAppealApplicationStatus(): Observable<ApplicantBasicInfoResponse> {
   // const params = new HttpParams().set('header_id', headerId);
    return this.http.get<ApplicantBasicInfoResponse>(`${this.appeal_info_url}/appeal/appeal-window/`)
  }

  getApplicantAppealDetails(index_no: string):Observable<AppealApplicantDetailsResponse> {
    const params: HttpParams = new HttpParams().set('index_no', index_no)
    return this.http.get<AppealApplicantDetailsResponse>(`${this.appeal_info_url}/appeal/get-applicant-appeal-details/`, {params});
  }

  postAppealApplicationDetails(request_body: FormData):Observable<ApplicantAppealModel> {
    return this.http.post<ApplicantAppealModel>(`${this.appeal_info_url}/appeal/get-applicant-appeal-details/`, request_body);
  }


  confirmAppealApplication(index_no: string):Observable<ApplicantAppealModel> {
    const params: HttpParams = new HttpParams().set('index_no', index_no)
    return this.http.put<ApplicantAppealModel>(`${this.appeal_info_url}/appeal/get-applicant-appeal-details/`, '',{params});
  }
  finishAndSubmitAppealApplication(index_no: string):Observable<ApplicantAppealModel> {
    const params: HttpParams = new HttpParams().set('index_no', index_no)
    return this.http.post<ApplicantAppealModel>(`${this.appeal_info_url}/appeal/submit-appeal-application/`, '',{params});
  }

  getAppealApplicationForm(index_no: string): Observable<any> {
    const req = {
      'index_no': index_no
    }
    return this.http.post(`${this.appeal_info_url}/appeal/get-applicant-pdf-form/`, req, {responseType: 'blob',
    });
  }

  getAppealRitaDetails(index_no: string, type: number, rita_no: string): Observable<AppealRitaDetails> {
    const params: HttpParams = new HttpParams().set('index_no',  index_no).set('rita_no', rita_no).set('type', type);
    return this.http.get<AppealRitaDetails>(`${this.appeal_info_url}/appeal/get-rita-birth-details/`,{params});
  }

  getTasafDetails(house_no: string): Observable<TasafAppealResponse> {
    const params: HttpParams = new HttpParams().set('house_no', house_no)
    return this.http.get<TasafAppealResponse>(`${this.appeal_info_url}/appeal/get-tasaf-details-appeal/`,{params});
  }
  public getAppealAttachment(url: string): Observable<any> {
    return this.http.get(url, {responseType: 'blob'
    });
  }

  uploadSignedForm(request_body: FormData):Observable<ApplicantAppealModel> {
    return this.http.put<ApplicantAppealModel>(`${this.appeal_info_url}/appeal/get-applicant-pdf-form/`, request_body);
  }
}
